export const GET_WAREHOUSES = "@Warehouse_GetWarehouses";



// WEBPACK FOOTER //
// ./src/app/store/reducers/warehouse/ActionsWarehouseReducer.ts